module.exports = __webpack_public_path__ + "img/HC1014-76.7f12fe58.jpg";